//
// DataItemInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/BIRDModel";
import "../../models/dataDefinition/DataItem";
import "./DataItemType";
import "./DataItemFilterType";
import "@sas-dvr/ltjs-commons/models/data/dataset/StatisticType";

var DataItemInfo = createModule("BIRD::DataItemInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        dataItem: 1,
        aggregationLabel: 7,
        formatLabel: 7,
        formatName: 7,
        aggregation: 4,
        assigned: 2,
        label: 7,
        type: 4,
        filterType: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DataItemInfo;
